import { APIRuntimeBuilder } from '@cian/mf-registry/browser';
import { setJsonQuery } from 'shared/actions/filterJsonQuery';
import { TReduxStore, TThunkDispatch } from 'shared/types/redux';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/set-filter-json-query',
      handler: async (data: { jsonQuery: object }) => {
        return (store.dispatch as TThunkDispatch)(setJsonQuery(data.jsonQuery));
      },
    },
  ];
}
